import { passwordRules } from "@/lib/passwordPolicy";

// Shared password-requirements checklist, used on every screen that sets a new
// password (DRY). Driven by the current input: each rule shows met/unmet live
// so the broker can see the password become valid as they type, instead of only
// learning the rules from a post-submit error. Server stays authoritative.
export function PasswordRequirements({ value }: { value: string }) {
  return (
    <div className="text-left text-sm text-brk-dim">
      <p id="password-requirements-label">Your password needs:</p>
      <ul
        aria-labelledby="password-requirements-label"
        className="mt-1 flex flex-col gap-0.5"
      >
        {passwordRules.map((rule) => {
          const met = rule.test(value);
          return (
            <li
              key={rule.id}
              data-met={met}
              className={met ? "text-green-700" : "text-brk-dim"}
            >
              <span aria-hidden="true">{met ? "✓" : "○"}</span>{" "}
              <span>{rule.label}</span>
              <span className="sr-only">
                {met ? " (met)" : " (not yet met)"}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
